import * as React from "react";
import style from "./Dialog.module.scss";
import type { ComponentFactory } from "./Dialogservice";



export const useInnerDialog = () => {
    const [
        dialogComponent,
        setDialogComponent
    ] = React.useState< React.ReactNode|null>(null);

   
    const [showInnerDialog, setShowInnerDialog] = React.useState(false);
    const [size, setSize] = React.useState("sm");

    function onInnerDialog<T>(factory: ComponentFactory, size?: "sm" | "md" | "xl" | "lg" ): Promise<T> {

        setSize( size || "sm");

        const promise = new Promise<T>((resolve, reject) => {
            const dialogContent = factory(resolve, reject);
            setDialogComponent(dialogContent);
            setShowInnerDialog(true);
        });

        promise.finally(() => {
            setShowInnerDialog(false);
            setDialogComponent(null);
        });

        return promise;
    };

const innerDialog = React.useMemo<React.ReactElement>( () =>  {
        if( showInnerDialog ) return <><div className={`${style.dialogBackdrop}`}>
                &nbsp;
            </div>
                <div className={`${style.dialogOuter}`}>
                    <div className={`${size}`}>
                        {dialogComponent}
                    </div>

                </div>
            </>

        return <></>;
            }, [dialogComponent, showInnerDialog, size]);




    return [ innerDialog, onInnerDialog ] as const;
};
